// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null,
}

const pit = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_PIT':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'GET_DATA_PIT_MEMBER':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'GET_PIT':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_PIT':
      return { ...state }
    case 'EDIT_PIT':
      return { ...state }
    case 'DELETE_PIT':
      return { ...state }
    default:
      return { ...state }
  }
}
export default pit
